import { Component } from '@angular/core';

import '../style/app.scss';

@Component({
  selector: 'my-app', // <my-app></my-app>
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')],
})
export class AppComponent {

  nativeWindow: any;

  constructor() {
  };

  public downloadVersion() {
    if (navigator.userAgent.indexOf('WOW64') !== -1 || navigator.userAgent.indexOf('Win64') !== -1) {
        window.open('https://www.dropbox.com/s/yym5zu2e8rah2t7/TurnOffAppSetup_x64.exe?dl=1','_self');
    } else {
        window.open('https://www.dropbox.com/s/ioklvw66hp9b1dn/TurnOffAppSetup_x32.exe?dl=1','_self');
    }
  };

  public mailToMe() {
    window.location.href = 'mailto:tomaszbread@gmail.com';
  };


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.component.ts